import { isProd } from '../config/config';

class KlaviyoTracker {
  static identifyUser = (email: string, firstName: string, lastName: string) => {
    if (!isProd) {
      // eslint-disable-next-line no-console
      console.log(`[mock] Klaviyo Identify: ${email}, ${firstName} ${lastName}`);
      return;
    }
    const data = {
      $email: email,
      $first_name: firstName,
      $last_name: lastName,
    };
    _learnq.push(['identify', data]);
  };

  static trackEvent = (event: string, data?: KlaviyoEventData) => {
    if (!isProd) {
      // eslint-disable-next-line no-console
      console.log(`[mock] Klaviyo Track: ${event}`, data);
      return;
    }
    _learnq.push(['track', event, data || {}]);
  };
}

export const KlaviyoTracking = {
  employer: KlaviyoTracker,
};
